import React from "react";
import { Navigate } from "react-router-dom";
import PermissionGuard from "../auth/PermissionGuard";
import ProtectedRoute from "../auth/ProtectedRoute";

/**
 * 全屏受保护布局
 * 适用于需要隐藏系统UI（导航栏、侧边栏）的全屏页面，如运营大屏
 * 仍然包含权限检查和登录验证
 */
const FullScreenProtectedLayout = ({ children, permission }) => {
    return (
        <ProtectedRoute>
            <PermissionGuard
                permission={permission}
                requireAll={Array.isArray(permission) ? false : true}
                fallback={<Navigate to="/" replace />}
            >
                <div style={{ 
                    width: "100vw", 
                    height: "100vh", 
                    overflow: "hidden", 
                    margin: 0, 
                    padding: 0,
                    position: "fixed",
                    top: 0,
                    left: 0,
                    zIndex: 9999
                }}>
                    {children}
                </div>
            </PermissionGuard>
        </ProtectedRoute>
    );
};

export default FullScreenProtectedLayout;
